import React, { useState,useEffect } from "react";
import Nabar from './Navbar';
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
import './Products.css';
function AllProducts() {
    const ID = Cookies.get("log_id");
    const [Products,setProducts] = useState([]);
    function FetchAllProducts() {
        axios.get(`${url.path}/all_products/`)
        .then((res) =>{
            if(res.data.status){
                var prod = res.data.products;
                setProducts([])
                prod.map((p)=>{
                    setProducts((prevState) =>[
                        ...prevState, p
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        FetchAllProducts();
    }, [])
    const itemsPerPage = 3;
        const [searchTerm, setSearchTerm] = useState("");
        const [currentPage, setCurrentPage] = useState(0);
    
        const filteredData = Products.filter((item) =>
          item.Name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    
        const offset = currentPage * itemsPerPage;
        const currentItems = filteredData.slice(offset, offset + itemsPerPage);
        const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    
        const handlePageClick = ({ selected }) => {
          setCurrentPage(selected);
        };
        function searchTable(){
          var rows = document.querySelectorAll('#productstable tbody tr');
          var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
          rows.forEach(function(row) {
            var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
            row.style.display = text.includes(val) ? '' : 'none';
          });
        }
        const [isFilterOpen, setIsFilterOpen] = useState(false);
        const [filters, setFilters] = useState({
          company: "all",
          graduation: "all",
          qualification: "all",
        });
      
        const toggleFilter = () => setIsFilterOpen(!isFilterOpen);
      
        const handleFilterChange = (e) => {
          const { name, value } = e.target;
          setFilters({ ...filters, [name]: value });
        };
      
        const clearFilters = () => {
          setCOMPANY("");
          setCategory("");
          setStatus("");
          toggleFilter();
        };
      
        // const applyFilters = () => {
        //   // Logic to filter products based on selected filters
        //   console.log("Filters Applied:", filters);
        //   setIsFilterOpen(false);
        // };
      
        const [companies,setCompanies] = useState([]);
        function all_Companies() {
            axios.get(`${url.path}/all_companies/`)
            .then((res) =>{
                if (res.data.status){
                    var cmp = res.data.companies;
                    setCompanies([])
                    cmp.map((p)=>{
                        setCompanies((prevState) =>[
                            ...prevState, p
                        ])
                })
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });
        }
        useEffect(() =>{
            all_Companies();
        }, [])
        const [COMPANY,setCOMPANY] = useState("");
        const [Category,setCategory] = useState("");
        const [Status,setStatus] = useState("");
        function applyFilters() {
          axios.get(`${url.path}/filter_products/`,{
              params:{
                  company:COMPANY,
                  statu:Status,
                  category:Category
              }
          })
          .then((res) =>{
              if(res.data.status){
                  var prod = res.data.products;
                  setProducts([])
                  prod.map((p)=>{
                      setProducts((prevState) =>[
                          ...prevState, p
                      ])
                  })
              }
          }).catch((err) => {
              console.log("ERROR", err);
            });
      }
    return(
        <>
        <Nabar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>All Products</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
            
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
        <div style={{ position: "relative",marginLeft:'auto' }}>
          <button className="filter-button" onClick={toggleFilter}>
            Filter <span>▼</span>
          </button>
          {isFilterOpen && (
            <div className="filter-panel">
              <div>
                <label>Company:</label>
                <select name="company" value={COMPANY} onChange={(e) =>setCOMPANY(e.target.value)} >
                  <option value="all">All</option>
                  {companies.map((company) => (
                    <option key={company} value={company.Company_name}>
                      {company.Company_name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label>Category:</label>
                <select name="graduation" value={Category} onChange={(e) =>setCategory(e.target.value)} >
                  <option value="all">All</option>
                  <option value="Food">Food</option>
                  <option value="Clothing">Clothing</option>
                  <option value="Daily Need">Daily Need</option>
                  <option value="House Items">House Items</option>
                </select>
              </div>
              <div>
                <label>Status:</label>
                <select value={Status} onChange={(e) =>setStatus(e.target.value)}>
                  <option value="all">All</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
              <div className="filter-actions">
                <button onClick={clearFilters}>Clear</button>
                <button onClick={applyFilters}>Apply</button>
              </div>
            </div>
          )}
        </div>
      </div>

      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Price</th>
            <th>Contact</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {Products.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Name}</td>
              <td>{i.Price}</td>
              <td>{i.Contact}</td>
              {i.Admin_Approved_Status == 'NULL' ? (
                <td>Pending</td>
              ) : (
                <td>{i.Admin_Approved_Status}</td>
              )}
              
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default AllProducts;